import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const MINIMENTAL_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.MINIMENTAL_SCALE,
  title: 'Mini-Mental State Examination (MMSE)',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: [
      'orientamento_tempo',
      'orientamento_luogo',
      'registrazione',
      'attenzione_calcolo',
      'richiamo',
      'linguaggio_prassia',
    ],
  },
  sections: [
    {
      name: 'mmse',
      label: 'Mini-Mental State Examination (MMSE)',
      fields: [
        // ORIENTAMENTO (TEMPO)
        {
          key: 'orientamento_tempo',
          label: 'Orientamento temporale',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            0: 'Nessuna risposta corretta su data, giorno, mese, stagione o anno.',
            1: 'Una risposta corretta.',
            2: 'Due risposte corrette.',
            3: 'Tre risposte corrette.',
            4: 'Quattro risposte corrette.',
            5: 'Tutte e cinque corrette.',
          },
          description:
            'Valuta la capacità di orientarsi nel tempo (es. data, giorno della settimana, stagione).',
        },
        // ORIENTAMENTO (LUOGO)
        {
          key: 'orientamento_luogo',
          label: 'Orientamento spaziale',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            0: 'Nessuna risposta corretta sul luogo attuale.',
            1: 'Una risposta corretta.',
            2: 'Due risposte corrette.',
            3: 'Tre risposte corrette.',
            4: 'Quattro risposte corrette.',
            5: 'Tutte e cinque corrette.',
          },
          description:
            'Valuta la capacità di identificare correttamente il luogo in cui ci si trova (es. edificio, città).',
        },
        // REGISTRAZIONE / MEMORIA IMMEDIATA
        {
          key: 'registrazione',
          label: 'Memoria immediata',
          type: 'number',
          min: 0,
          max: 3,
          step: 1,
          maxScore: 3,
          valueDescriptions: {
            0: 'Non ricorda nessuna delle parole.',
            1: 'Ricorda una parola.',
            2: 'Ricorda due parole.',
            3: 'Ricorda tutte le parole.',
          },
          description:
            'Valuta la capacità di ripetere immediatamente una breve lista di parole.',
        },
        // ATTENZIONE E CALCOLO
        {
          key: 'attenzione_calcolo',
          label: 'Attenzione e calcolo',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            0: 'Prestazione assente o completamente errata.',
            1: 'Prestazione minima.',
            2: 'Prestazione limitata.',
            3: 'Prestazione moderata.',
            4: 'Buona prestazione.',
            5: 'Prestazione ottimale.',
          },
          description:
            "Valuta la capacità di mantenere l'attenzione durante un compito numerico o sequenziale.",
        },
        // RICHIAMO / MEMORIA A BREVE TERMINE
        {
          key: 'richiamo',
          label: 'Memoria di richiamo',
          type: 'number',
          min: 0,
          max: 3,
          step: 1,
          maxScore: 3,
          valueDescriptions: {
            0: 'Non ricorda nessuna parola.',
            1: 'Ricorda una parola.',
            2: 'Ricorda due parole.',
            3: 'Ricorda tutte le parole.',
          },
          description:
            'Valuta la memoria a breve termine richiedendo di ricordare parole apprese poco prima.',
        },
        // LINGUAGGIO E PRASSIA
        {
          key: 'linguaggio_prassia',
          label: 'Linguaggio e prassia',
          type: 'number',
          min: 0,
          max: 9,
          step: 1,
          maxScore: 9,
          valueDescriptions: {
            0: 'Nessun compito eseguito correttamente.',
            3: 'Esecuzione parziale dei compiti.',
            6: 'Buona esecuzione della maggior parte dei compiti.',
            9: 'Esecuzione completa e corretta di tutti i compiti.',
          },
          description:
            'Valuta linguaggio, denominazione, ripetizione, comprensione, lettura, scrittura e semplici compiti costruttivi.',
        },
      ],
    },
  ],
  computedFields: [
    // PUNTEGGIO TOTALE
    {
      key: 'totale',
      label: 'Punteggio totale',
      type: 'number',
      calculation: 'SUM(scoreConfig.scoreFields)',
      maxScore: 30,
    },
    // INTERPRETAZIONE CLINICA AUTOMATICA
    {
      key: 'interpretazione',
      label: 'Interpretazione clinica',
      type: 'text',
      calculation: `
        IF(totale >= 24, "Funzione cognitiva nella norma o con lieve deficit",
          IF(totale >= 20, "Compromissione cognitiva lieve",
            IF(totale >= 10, "Compromissione cognitiva moderata",
              "Compromissione cognitiva severa"
            )
          )
        )
      `,
      maxScore: 0,
    },
  ],
};
